import React from 'react';
import { Speedometer2 } from 'react-bootstrap-icons';
import { ChipBackgroundColor, ChipLabelColor } from '../Chip/types';
import Chip from '../Chip/Chip';
import { ComplexityLevel } from './types';

interface ComplexityChipProps {
  complexity?: ComplexityLevel;
}
const ComplexityChip = ({
  complexity = ComplexityLevel.MEDIUM,
}: ComplexityChipProps) => {
  const colors = React.useMemo(() => {
    switch (complexity) {
      case ComplexityLevel.SIMPLE:
        return {
          bgColor: ChipBackgroundColor.GREEN,
          labelColor: ChipLabelColor.GREEN,
        };
      case ComplexityLevel.COMPLEX:
        return {
          bgColor: ChipBackgroundColor.RED,
          labelColor: ChipLabelColor.RED,
        };
      default:
        return {
          bgColor: ChipBackgroundColor.YELLOW,
          labelColor: ChipLabelColor.YELLOW,
        };
    }
  }, [complexity]);
  return (
    <Chip
      labelText={complexity}
      icon={<Speedometer2 size={12} />}
      backgroundColor={colors.bgColor}
      labelColor={colors.labelColor}
    />
  );
};

export default ComplexityChip;
